import { createFileRoute } from '@tanstack/react-router';
import { LandingRouteComponent } from './-LandingRouteComponent';

export const Route = createFileRoute('/landing')({
  component: LandingRouteComponent,
});
